import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { deleteRequest, getRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';
import AdminTable from 'common/AdminTable';
import TruncatedMessage from 'common/TruncatedMessage';

const ListRepoters = () => {
  const navigate = useNavigate();
  const backendBase = useMemo(() => (process.env.REACT_APP_BACKEND || '').replace(/\/+$/, ''), []);

  const [repoters, setRepoters] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchRepoters = async () => {
    try {
      setLoading(true);
      const response = await getRequest('repoter');
      setRepoters(Array.isArray(response?.data) ? response.data : []);
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to load repoters');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRepoters();
  }, []);

  const handleDelete = async (id) => {
    const confirmed = window.confirm('Delete this repoter?');
    if (!confirmed) return;

    try {
      await deleteRequest(`repoter/${id}`);
      toast.success('Repoter deleted successfully');
      fetchRepoters();
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to delete repoter');
    }
  };

  const tableHeaders = [
    {
      Header: 'ID',
      accessor: 'id'
    },
    {
      Header: 'Image',
      accessor: 'image',
      Cell: ({ row }) =>
        row.original.image ? (
          <img
            src={`${backendBase}/uploads/repoters/${row.original.image}`}
            alt={row.original.name}
            width={56}
            height={56}
            style={{ objectFit: 'cover', borderRadius: '50%' }}
          />
        ) : (
          '-'
        )
    },
    {
      Header: 'Name',
      accessor: 'name'
    },
    {
      Header: 'Email',
      accessor: 'email'
    },
    {
      Header: 'Mobile',
      accessor: 'mobile'
    },
    {
      Header: 'Address',
      accessor: 'address',
      Cell: ({ row }) => <TruncatedMessage text={row.original.address || '-'} maxLength={50} />
    },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: ({ row }) => (
        <>
          <button className="btn btn-primary mx-1" onClick={() => navigate(`/repoters/update/${row.original.id}`)}>
            Edit
          </button>
          <button className="btn btn-danger mx-1" onClick={() => handleDelete(row.original.id)}>
            Remove
          </button>
        </>
      )
    }
  ];

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Repoters List</h4>
      </div>

      {loading ? <p className="mx-4 text-white">Loading...</p> : null}

      {!loading && repoters.length === 0 ? <p className="mx-4 text-white">No repoters found.</p> : null}

      {!loading && repoters.length > 0 ? <AdminTable tableHeaders={tableHeaders} tableData={repoters} /> : null}
    </div>
  );
};

export default ListRepoters;
